// extracted by mini-css-extract-plugin
export default {"scroll":"ScrollUp_scroll__1hXlQ","icon":"ScrollUp_icon__N8+ea"};